<template>
  <div class="section-right-content-box" v-loading="loading">
    <div class="top-box">
      <div class="top-box-s">
        <div class="title-box" style="margin-bottom: 18px;">汇总数据</div>
        <el-form label-width="10px">
          <el-form-item>
            <span style="margin-right: 20px">统计时间 :</span>
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="postForm.summaryTimeStart"
                type="date"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div class="time_to_text" style="background: #ffffff;">
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="postForm.summaryTimeEnd"
                type="date"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="false"
              ></el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="clearTimeSendTime()"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt
                class="date_icon2"
              />
            </div>
            <el-select
              v-model="activityType"
              placeholder="请选择"
              v-if="activityTypeParent"
            >
              <el-option
                v-for="item in activityTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              class="b1"
              style="margin-left: 20px"
              @click="queryTotal()"
              >查询</el-button
            >
            <el-button class="b2" style="margin-left: 20px" @click="onReset()"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- 下单转化 -->
      <div class="titClass">
        <div class="titClassOne" v-for="(v, index) in summaryList" :key="index">
          <div style="color: #333333; font-size: 14px">
            {{ v.name }}
          </div>
          <div style="color: #1f1f1f; font-size: 18px; font-weight: 600">
            {{ summaryData[v.prop] }}
          </div>
        </div>
      </div>
    </div>
    <div class="new-table-box" style="margin-top: 20px">
      <div class="between-box">
        <div class="title-box">每日数据</div>
        <el-button type="default" @click="onExport">导出</el-button>
      </div>
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%;"
      >
        <el-table-column prop="statsDate" label="日期"> </el-table-column>
        <el-table-column prop="activityPv" label="活动PV"> </el-table-column>
        <el-table-column prop="activityUv" label="活动UV"> </el-table-column>
        <el-table-column prop="incrMemberCount" label="入会人数">
        </el-table-column>
        <el-table-column prop="downloadUv" label="下载人数"> </el-table-column>
        <el-table-column prop="downloadPv" label="下载次数"> </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          background
          style="text-align: right; margin-top: 20px;"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="postForm.current"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="postForm.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import topTitle from "@/components/top-title";
import {
  deeyeoClickEventSummary,
  deeyeoClickEventDailySummary,
  deeyeoClickEventSummaryExport,
  configDetail,
} from "@/api/deeyeo.js";
export default {
  components: {
    topTitle,
  },
  data() {
    return {
      summaryList: [
        {
          name: "活动pv",
          prop: "activityPv",
        },
        {
          name: "活动UV",
          prop: "activityUv",
        },
        {
          name: "入会人数",
          prop: "incrMemberCount",
        },
        {
          name: "下载人数",
          prop: "downloadUv",
        },
        {
          name: "下载次数",
          prop: "downloadPv",
        },
      ],
      summaryData: {
        activityPv: 0,
        activityUv: 0,
        incrMemberCount: 0,
        downloadUv: 0,
        downloadPv: 0,
      },
      postForm: {
        summaryTimeStart: "",
        summaryTimeEnd: "",
        size: 10,
        current: 1,
      },
      loading: true,

      activityTypeParent: "",
      activityType: "",
      defaultIndex: 0,
      decorationInfoId: "", //模板id
      miniappAutoName: "", //小程序
      tableData: [],
      total: 0,
    };
  },
  created() {},
  mounted() {},
  methods: {
    async initData() {
      let timeArr = this.$getActDate(-6, new Date());
      let startTime = timeArr[1].split(" ")[0].substr(0, 10) + " 00:00:00";
      let endTime = timeArr[0].split(" ")[0].substr(0, 10) + " 23:59:59";
      this.postForm.summaryTimeStart = startTime;
      this.postForm.summaryTimeEnd = endTime;
      console.log("kkk>>", timeArr);
      let res = await configDetail();
      this.decorationInfoId = res.data.id || "";
      this.getEventSummary();
      this.getDailySummary();
    },
    async getEventSummary() {
      let startTime =
        this.postForm.summaryTimeStart.substr(0, 10) + " 00:00:00";
      let endTime = this.postForm.summaryTimeEnd.substr(0, 10) + " 23:59:59";
      const res = await deeyeoClickEventSummary({
        decorationInfoId: this.decorationInfoId,
        ...this.postForm,
        summaryTimeStart: startTime,
        summaryTimeEnd: endTime,
      });
      if (res.code == 1) {
        this.summaryData = res.data;
      }
    },

    async getDailySummary() {
      this.loading = true;
      let startTime =
        this.postForm.summaryTimeStart.substr(0, 10) + " 00:00:00";
      let endTime = this.postForm.summaryTimeEnd.substr(0, 10) + " 23:59:59";
      try {
        const res = await deeyeoClickEventDailySummary({
          decorationInfoId: this.decorationInfoId,
          ...this.postForm,
          summaryTimeStart: startTime,
          summaryTimeEnd: endTime,
        });
        this.loading = false;
        if (res.code == 1) {
          let list = res.data.records || [];
          this.total = Number(res.data.total);
          this.tableData = list;
        }
      } catch (err) {
        this.loading = false;
      }
    },

    async onExport() {
      let startTime =
        this.postForm.summaryTimeStart.substr(0, 10) + " 00:00:00";
      let endTime = this.postForm.summaryTimeEnd.substr(0, 10) + " 23:59:59";
      const res = await deeyeoClickEventSummaryExport({
        decorationInfoId: this.decorationInfoId,
        ...this.postForm,
        summaryTimeStart: startTime,
        summaryTimeEnd: endTime,
      });
      if (res.code == 1) {
        let Time = new Date().toLocaleString();
        let blob = new Blob([res.blob]);
        let link = document.createElement("a"); //a标签下载
        link.href = window.URL.createObjectURL(blob);
        link.download = "数据统计" + Time + ".xlsx";
        link.click();
        window.URL.revokeObjectURL(link.href);
      } else {
        this.$message.error(res.message);
      }
    },
    queryTotal() {
      this.getEventSummary();
      this.getDailySummary();
    },
    //重置
    onReset() {
      this.initData();
    },
    clearTimeSendTime() {
      this.postForm.summaryTimeStart = "";
      this.postForm.summaryTimeEnd = "";
    },
    handleSizeChange(val) {
      this.postForm.size = val;
      this.getDailySummary();
    },
    handleCurrentChange(val) {
      this.postForm.current = val;
      this.getDailySummary();
    },
  },
};
</script>

<style lang="scss" scoped>
.tip-wrap {
  margin-bottom: 16px;
}
.switch {
  margin-top: 16px;
  &-tabs {
    /deep/.el-tabs__header {
      margin-bottom: 0px;
    }
    /deep/.el-tabs__nav-wrap::after {
      background-color: #f6f6f6;
    }
  }
}
.question_iconOne {
  width: 13px;
  height: 13px;
  display: inline-block;
  line-height: 13px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #ccc;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 4px;
  color: #ccc;
}

.titileDefinition {
  min-width: 1046px;
  height: 57px;
  line-height: 57px;
  padding: 0 20px;
  margin: 20px 20px 0 20px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  font-size: 16px;
  color: #2e3458;
  font-weight: bold;
  background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
}

.titClass {
  padding: 36px 24px;
  // margin: 35px;
  margin-bottom: 25px;
  background: #fafafa;
  opacity: 1;
  display: flex;
  align-items: center;
  line-height: 22px;
  position: relative;
  justify-content: space-between;
  .titClassOne {
    margin: 0px 100px 0px 30px;
    text-align: center;
  }
  .down {
    margin-right: 30px;
  }
  .borderU {
    position: absolute;
    width: 1px;
    height: 110px;
    background: #f3f3f3;
    left: 122px;
  }
}

.section-right-content-box {
  min-width: 1046px;
  border-bottom: 6px;
  // padding: 20px;
  background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  // margin: 0 20px 20px 20px;
  .tabList {
    display: flex;
    box-sizing: border-box;
    height: 36px;
    line-height: 35px;
    // margin-top: 20px;
    color: #666;
    font-size: 14px;
    margin: 20px 0;
    span {
      margin-right: 3px;
      width: 106px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      vertical-align: middle;
      transform: perspective(1px) translateZ(0);
      box-shadow: 0 0 1px rgba(0, 0, 0, 0);
      border-radius: 2px 2px 0px 0px;
      border: 1px solid #dddddd;
      text-align: center;
    }
    .active {
      position: relative;
      transition: all 0.2s;
      color: #7b61ff;
      border-bottom: none;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        width: 100%;
        top: 0;
        height: 2px;
        background: #7b61ff;
        border-radius: 6px 6px 0px 0px;
      }
    }
    i {
      flex: 1;
      border-bottom: 1px solid #dddddd;
      margin-left: -3px;
    }
  }
  .b1 {
    width: 98px;
    height: 32px;
    color: #fff;
    border: 1px solid #7b61ff;
    background-color: #7b61ff;
    &:hover {
      opacity: 0.8;
    }
  }
  .b2 {
    width: 98px;
    height: 32px;
    color: #7b61ff;
    border: 1px solid #7b61ff;
    background-color: #fff;
    &:hover {
      color: #fff;
      border: 1px solid #7b61ff;
      background-color: #7b61ff;
    }
  }
  .background {
    height: 32px;
    background: rgba(250, 250, 250, 1);
    opacity: 1;
    line-height: 32px;
    padding-left: 12px;
    .title {
      display: inline-block;
      width: 2px;
      height: 14px;
      background: #7b61ff;
      opacity: 1;
      border-radius: 3px;
      vertical-align: middle;
    }
    .tips {
      width: 56px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
      vertical-align: middle;
    }
  }

  .overview1 {
    padding: 26px 30px 22px 30px;
    width: 182px;
    height: 100px;
    border-right: 1px solid #f3f3f3;
    opacity: 1;
    margin: 20px 0px;
    .fontClass {
      width: 102px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(102, 102, 102, 1);
      opacity: 1;
    }
    .iconbtn_yiwen {
      color: #cccccc;
      font-size: 13px;
      &:hover {
        color: #7b61ff;
      }
    }
    .question_icon {
      width: 14px;
      height: 14px;
      color: #cccccc;
      display: inline-block;
      line-height: 12px;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #cccccc;
      font-size: 12px;
      font-weight: normal;
    }
    .num {
      width: 65px;
      height: 29px;
      font-size: 24px;
      font-family: DIN;
      font-weight: bold;
      line-height: 29px;
      color: #7b61ff;
      opacity: 1;
      margin-top: 14px;
      margin-bottom: 30px;
    }
  }
  .chart {
    // flex: 1;
    height: 380px;
    min-width: 1000px;
  }
}
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 9px 14px;
  display: flex;
  .card-rule {
    // background: url("../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.top-box {
  background: #fafafa;
  padding: 20px 10px 0 10px;
}
.title-box {
  font-size: 16px;
  font-weight: bold;
}
.top-box-s {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
}
.between-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px 20px 10px;
}
</style>
